import { FormContextType } from '@components/DisplayForm/types'

import { DisplayFormExtendedProps, DisplayFormProps } from '../DisplayForm'
import { useDisplayForm } from '../hooks/useDisplayForm'

type Props = {
  data: ReturnType<typeof useDisplayForm>['data']
  state: ReturnType<typeof useDisplayForm>['state']
  handlers: ReturnType<typeof useDisplayForm>['handlers']
  formTitle: string | null
  formProps: DisplayFormProps & DisplayFormExtendedProps
}

export const getContextValue = (props: Props): FormContextType => {
  const { data, state, handlers, formTitle, formProps } = props

  const {
    passedParams,
    handleRemoveSamePageForm,
    onSetOpenedContainersInStaticForms,
    // TODO необходим рефакторинг, скорее всего оставить данную логику только для статичных форм и вынести наружу
    samePageFormsData,
    selectedRowIds,
    skipHotKeyPress,
    windowHeight,
    onSetWindowTitle,
    dialogId,
    isSectionWindow,
    formContainersConfig,
    formConfig,
    instanceId,
  } = formProps

  const { globalId, objectId } = passedParams

  const {
    form,
    links,
    viewCode,
    isFetchingForm,
    isFetchingFormError,
    withPassedParams,
    isViewType,
    viewPath,
    isDirty,
    methods,
    outerVariables,
  } = data

  const {
    currentRow,
    isViewEdit,
    defaultValues,
    isDeleteRow,
    isDropdownWindowOpenFormState,
    initialCommonParameters,
    isLoadingRow,
    currentLink,
    isSaveByEnterDisabled,
    isSuccessUpdateObjectData,
    isPendingCreateOrUpdateForm,
    latestVariables,
    isInitialValuesForCreateFormInitialized,
  } = state

  const {
    handleDataForNewForm,
    handleSetType,
    handleOpenLink,
    handleEditOrSaveClick,
    handleCancel,
    handleResetEdit,
    handleSetDropdownWindowOpenFormState,
    reset,
    setValueOnForm,
    watch,
    handleSetSaveByEnterDisabled,
    handleSetHasUnsavedChanges,
  } = handlers

  return {
    dialogId,
    isDropdownWindowOpenFormState,
    handleSetDropdownWindowOpenFormState,
    form,
    globalId,
    links,
    viewCode: viewCode ?? '',
    row: currentRow ?? {},
    type: currentLink.event,
    isLoadingRow,
    onSetNewForm: handleDataForNewForm,
    isFetchingForm,
    isPendingCreateOrUpdateForm,
    isFetchingFormError,
    onSetType: handleSetType,
    viewPath,
    isSaveByEnterDisabled,
    handleSetSaveByEnterDisabled,
    withPassedParams,
    formDataId: passedParams.id,
    containers: formContainersConfig,
    objectCode: currentLink.objectCode,
    openLink: handleOpenLink,
    isViewType,
    isViewEdit,
    handleEditOrSaveClick,
    handleCancel,
    onResetEdit: handleResetEdit,
    methods,
    isDirty,
    reset,
    defaultValues,
    isDeleteRow,
    objectId,
    handleRemoveSamePageForm,
    onSetOpenedContainersInStaticForms,
    samePageFormsData,
    selectedRowIds,
    skipHotKeyPress,
    initialCommonParameters,
    windowHeight,
    formTitle,
    onSetWindowTitle,
    currentLink,
    setValueOnForm,
    watch,
    isSuccessUpdateObjectData,
    formCodeToFetchBy: formConfig.code,
    isSectionWindow,
    handleSetHasUnsavedChanges,
    latestVariables,
    outerVariables,
    formConfig,
    instanceId,
    isInitialValuesForCreateFormInitialized,
  }
}
